import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { mapActions, mapGetters, mapState } from "vuex";
import User from "@/components/User.vue";
import Money from "@/components/Money.vue";
import Avatar from "@/components/Avatar.vue";
import CompanyCard from "@/Pages/Reports/CompanyCard.vue";
import ReportCard from "@/Pages/Reports/ReportCard.vue";
import Doughnut from "@/components/Charts/Doughnut.vue";
import { debounce } from "lodash";
let Reports = class Reports extends Vue {
    user;
    dates;
    branchesId;
    isLoading;
    fetchReports;
    findReportsStore;
    getUser;
    get report() {
        const defaults = {
            byMethod: { current: {}, percentage: {} },
            summary: { current: {}, percentage: {} },
            byStaff: []
        };
        return this.findReportsStore().data[0] || defaults;
    }
    get byMethod() {
        return this.report.byMethod;
    }
    get summary() {
        return this.report.summary;
    }
    get byStaff() {
        return this.report.byStaff.map(el => {
            let user = this.getUser(el.staffId);
            return { _id: `${user.firstName} ${user.lastName}`, count: el.total };
        });
    }
    get queryParams() {
        let query = {};
        if (this.dates.start) {
            query.expenseOn = {
                $gte: this.dates.start,
                $lte: this.dates.end
            };
        }
        if (this.branchesId.length > 0)
            query.branchesId = this.branchesId;
        if (this.user.length > 0) {
            query.staffId = { $in: this.user };
        }
        return query;
    }
    get percentTooltip() {
        return this.$t('Change rate');
    }
    fetchReportsLocal = debounce(() => {
        this.fetchReports({ query: this.queryParams });
    }, 200);
    fetchExpenseReport() {
        this.fetchReportsLocal();
    }
    mounted() {
        this.fetchReportsLocal();
        this.$root.$on("bv::hide::modal", () => {
            this.fetchReportsLocal();
        });
    }
};
__decorate([
    Prop(Array)
], Reports.prototype, "user", void 0);
__decorate([
    Prop(Object)
], Reports.prototype, "dates", void 0);
__decorate([
    Prop(Array)
], Reports.prototype, "branchesId", void 0);
__decorate([
    Watch('queryParams')
], Reports.prototype, "fetchExpenseReport", null);
Reports = __decorate([
    Component({
        components: { Doughnut, ReportCard, CompanyCard, Avatar, Money, User },
        methods: {
            ...mapActions('expense-reports', { fetchReports: 'find' }),
        },
        computed: {
            ...mapState('expense-reports', { isLoading: 'isFindPending' }),
            ...mapGetters('expense-reports', { findReportsStore: 'find' }),
            ...mapGetters('my-team', { getUser: 'get' })
        }
    })
], Reports);
export default Reports;
